// @owners { team: patients }
import { Card, LgPadding, MdSpacing } from '@alto/design-system';
import { type CartItem } from '@alto/orders_api/types/v1/cart_item';
import { type AddOnOtc } from '@alto/scriptdash/alto/patient_app/add_ons/types/v1/add_on_otc';
import React from 'react';
import { View } from 'react-native';
import { type ItemKey } from '~shared/features/checkout/types';
import { getPrescriptionByID } from '~shared/features/prescriptions/selectors/getPrescriptionByID';
import { useSelectorShared } from '~shared/store';
import { ORDER_TYPE_CONTEXT } from '../../auto-refill';
import { useEditEssential } from '../../essentials/hooks/useEditEssential';
import { MedicationItem } from '../../medication-item';

type CartItemProps = {
  readonly cartItem: CartItem;
  readonly essentialsHash: Record<string, AddOnOtc>;
  readonly openEditMedicationFlow: ({ itemKey, prescriptionID }: { itemKey: ItemKey; prescriptionID: number }) => void;
};

export const CartMedicationItem = ({ cartItem, essentialsHash, openEditMedicationFlow }: CartItemProps) => {
  let essential: AddOnOtc | undefined;
  const prescriptionID = cartItem.resource_id;
  const prescription = useSelectorShared((state) => getPrescriptionByID(state, prescriptionID));
  if (prescription?.is_add_on_otc && prescription.product_id) {
    essential = essentialsHash[prescription.product_id];
  }
  const { onChangeEssential } = useEditEssential({ essential });

  return (
    <View key={cartItem.resource_id}>
      <Card>
        <LgPadding>
          <MedicationItem
            essentialsHash={essentialsHash}
            canEditMedication
            onChangeEssential={onChangeEssential}
            openEditMedicationFlow={openEditMedicationFlow}
            orderTypeContext={ORDER_TYPE_CONTEXT.ADD_TO_CART}
            prescriptionID={cartItem.resource_id}
            userID={cartItem.patient_id}
          />
        </LgPadding>
      </Card>
      <MdSpacing />
    </View>
  );
};
